import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { SET_ERROR_MESSAGE, RESET_ERROR_MESSAGE, SET_ERROR_FLAG } from "./error.action";

export interface ErrorModel {
  status: null;
  timestamp: null;
  detail: {
    code: null;
    error: null;
    message: null;
    isError: boolean;
  };
}
@Injectable()
@State<ErrorModel>({
  name: "ErrorState",
  defaults: {
    status: null,
    timestamp: null,
    detail: {
      code: null,
      error: null,
      message: null,
      isError: false,
    },
  },
})
export class ErrorState {
  constructor() {}

  @Selector()
  public static error(state: ErrorModel) {
    return state.detail;
  }

  @Selector()
  public static status(state: ErrorModel) {
    return state.detail.isError;
  }

  @Action(SET_ERROR_FLAG)
  public setErrorflag({ patchState }: StateContext<ErrorModel>, { payload }: SET_ERROR_MESSAGE) {
    patchState({
      detail: {
        code: payload.code,
        error: null,
        message: null,
        isError: true,
      },
      status: payload.status,
    });
  }

  @Action(SET_ERROR_MESSAGE)
  public setErrorMessage({ patchState }: StateContext<ErrorModel>, { payload }: SET_ERROR_MESSAGE) {
    patchState({
      detail: {
        code: payload.status,
        error: payload.error == null || payload.error == "" ? "Service Unavailable" : payload.error,
        message: payload.message == null || payload.message == "" ? "The service is temporarily unavailable. Please try again later." : payload.message,
        isError: true,
      },
      status: payload.status,
    });
  }

  @Action(RESET_ERROR_MESSAGE)
  public resetErrorMessage({ patchState }: StateContext<ErrorModel>) {
    patchState({
      detail: {
        code: null,
        error: null,
        message: null,
        isError: false,
      },
      status: null,
    });
  }
}
